import { underscore } from 'inflected';

export class TextUtility {

    public static toCamelCase(text: string): string {
        const camel = text
            .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
            .replace(/\s/g, '')
            .replace(/^(.)/, function ($1) { return $1.toLowerCase(); })
            .replace(/\//g, '');

        return camel;
    }

    // Prevent character that can cause issues in the form engine
    // - & cause issue when rendering form PDF using LinQ Report Engine
    public static excludeSpecialCharacters(text: string): string {
        const safeText = text.replace('&', '');
        return safeText;
    }

    public static toUnderscoreCase(text: string): string {
        const camel = this.toCamelCase(text);
        return underscore(camel);
    }
}